import React from 'react';
import { PolarArea } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, RadialLinearScale } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, RadialLinearScale);

const polarChartData = {
    labels: [" فروش", "وصول شده", "تکمیل شده", "لغو شده", "موفقیت"],
    datasets: [{
        borderColor: "#fff",
        backgroundColor: ["#9cabff", "#f4aaa4", "#9785FF", "#E85347", "#8feac5"],
        data: [1100000, 1500000, 1680000, 450000, 2350000]
    }]
};

const options = {
    plugins: {
        legend: {
            display: false,
            labels: {
                boxWidth: 12,
                padding: 20,
                fontColor: '#6783b8'
            }
        },
        tooltip: {
            callbacks: {
                title: function (tooltipItem) {
                    return polarChartData.labels[tooltipItem[0].dataIndex];
                },
                label: function (tooltipItem) {
                    return new Intl.NumberFormat('fa-IR', { style: 'currency', currency: 'IRR' }).format(polarChartData.datasets[0].data[tooltipItem.dataIndex]);
                }
            },
            backgroundColor: '#000',
            titleFontSize: 13,
            titleFontColor: '#6783b8',
            titleMarginBottom: 6,
            bodyFontColor: '#9eaecf',
            bodyFontSize: 12,
            bodySpacing: 4,
            yPadding: 10,
            xPadding: 10,
            footerMarginTop: 0,
            displayColors: true
        }
    },
    maintainAspectRatio: false
};

const SaleAndReceipts = () => {
    return (
        <div className="card ">
            <div className="card-inner">
                <div className="card-title-group pb-1 g-2 chart-title-bg">
                    <div className="card-title">
                        <h6 className="title">وضعیت پروژه‌ها</h6>
                        <p>وضعیت پروژه‌ها در این ماه.</p>
                    </div>
                    <div className="card-tools shrink-0 d-none d-sm-block">
                        <ul className="nav nav-switch-s2 nav-tabs bg-white">
                            <li className="nav-item">
                                <a href="#" className="nav-link">۷ روز</a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link active">۱ ماه</a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link">۳ ماه</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="analytic-ov d-flex flex-row">
                    <div className="analytic-data-group analytic-ov-group flex-column g-3 mt-2 col-md-6">
                        <div className="analytic-data analytic-ov-data">
                            <div className="title"> فروش</div>
                            <div className="amount">۱۱۰,۰۰۰ تومان</div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">وصول شده</div>
                            <div className="amount">۱۵۰,۰۰۰ تومان</div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">تکمیل شده</div>
                            <div className="amount">۱۵۰,۰۰۰ تومان</div>
                        </div>
                        <div className="analytic-data analytic-ov-data">
                            <div className="title">لغو شده</div>
                            <div className="amount">۱۵۰,۰۰۰ تومان</div>
                        </div>
                    </div>
                    <div className="analytic-ov-ck col-md-6">
                        <PolarArea data={polarChartData} options={options} />
                        <div className="chart-label-group ms-5">
                            <div className="chart-label">۱ دی, ۱۴۰۰</div>
                            <div className="chart-label d-none d-sm-block">۱۵ دی, ۱۴۰۰</div>
                            <div className="chart-label">۳۰ دی, ۱۴۰۰</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SaleAndReceipts;
